import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#65C3FF', cx: '12', cy: '12', r: '12' }),
    React.createElement("path", { key: '1', fill: '#FFFFFF', d: 'M4.7,12.7H3.9v2.8H2.2V8.4h1.7v2.7h0.7L6,8.4h2l-2,3.3l2.2,3.8h-2L4.7,12.7z' }),
    React.createElement("path", { key: '2', fill: '#FFFFFF', d: 'M14.6,15.6h-1.7V9.8h-2.6v5.8H8.7V8.4h6L14.6,15.6L14.6,15.6z' }),
    React.createElement("path", { key: '3', fill: '#FFFFFF', d: 'M21.7,15.6H20V9.8h-2.6v5.8h-1.7V8.4h6V15.6z' }),
], 'TransportConditionGeofenceCheckpoint');
const TransportConditionGeofenceCheckpointIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({ xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props));
};
export default memo(TransportConditionGeofenceCheckpointIcon);
